import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandPaper, faCheck, faShare, faTimesCircle, faPen } from '@fortawesome/free-solid-svg-icons'
import AppBadge from './app-badge'

const ACTION_CONFIG = {
  A: { variant: 'success', icon: faCheck },
  R: { variant: 'danger', icon: faTimesCircle },
  F: { variant: 'secondary', icon: faShare },
  C: { variant: 'secondary', icon: faPen },
  H: { variant: 'secondary', icon: faHandPaper }
}

function WorkflowActionBadge({ action }) {
  const config = ACTION_CONFIG[action] || { variant: 'secondary', icon: faCheck }

  return (
    <AppBadge pill variant={config.variant} className="text-center fw-normal">
      <FontAwesomeIcon icon={config.icon} className="me-1" />
      {action}
    </AppBadge>
  )
}

export default WorkflowActionBadge
